import { render, staticRenderFns } from "./modalJson.vue?vue&type=template&id=3b7366ac&scoped=true"
import script from "./modalJson.vue?vue&type=script&lang=js"
export * from "./modalJson.vue?vue&type=script&lang=js"
import style0 from "./modalJson.vue?vue&type=style&index=0&id=3b7366ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7366ac",
  null
  
)

export default component.exports